/** Общие константы виджетов расхода корма (large, full) */
export const FEED_CONSUMPTION_CHART_WIDGET = {
	title: 'Расход корма и остатки',
	path: 'analytics/feeding',
	pathLabel: 'Перейти в аналитику кормления',
} as const

export const FEED_CONSUMPTION_MESSAGES = {
	errorTitle: 'Ошибка загрузки данных',
	errorDescription: 'Не удалось загрузить данные. Попробуйте позже.',
	emptyTitle: 'Нет данных',
	emptyDescription: 'Нет данных, соответствующих заданным условиям.',
} as const
